<template>
  <div class="main-area">
    <el-page-header @back="goBack" content="人员绑定"></el-page-header>
    <el-form
      :inline="true"
      :model="formData"
      class="demo-ruleForm"
      label-width="100px"
      :rules="formRules"
      ref="formData"
      :size="GLOBAL.config.systemSize"
      element-loading-text="数据处理中...请稍等..."
      :disabled="false"
      v-loading="loading">
      <el-row class="margin-top-20">
        <el-col :span="10">
          <el-form-item label="区域：" prop="ssxzbm">
            <cascader :set-props="setProps"
                      :set-size="GLOBAL.config.systemSize" maxlength="64"
                      ref="myArea" :is-disabled="true"></cascader>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="车牌号：" prop="cph">
            <el-input v-model="formData.cph" placeholder="车牌号" maxlength="64" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">驾驶员信息</el-divider>
      <el-table style="width: 100%"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading" highlight-current-row @current-change="handleCurrentChange" ref="singleTable">
        <!--序号-->
        <el-table-column type="index" label="序号" width="80px" align="center"/>
        <!--姓名-->
        <el-table-column prop="xm" label="姓名" align="center"/>
        <!--手机号码-->
        <el-table-column prop="sjh" label="手机号码" align="center"/>
      </el-table>
      <el-pagination
        class="margin-top-10 margin-bottom-20"
        @size-change="tableSizeChange"
        @current-change="currentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizeList"
        :page-size="pagination.pageSize"
        :layout="pagination.layout"
        :total="pagination.total">
      </el-pagination>
      <el-row class="margin-top-20">
        <el-button @click="goBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
        <el-button v-if="editableFlag" type="primary" @click="saveForm" style="margin: 0 20px;"
                   :size="GLOBAL.config.systemSize">添加人员
        </el-button>
      </el-row>
    </el-form>
    <!--操作-->
<!--    <careditor ref="careditor" />-->

  </div>
</template>
<script>
  // import addCarUserTemplate from '.././villager/VillagerSimpleTableDialog'
  import cascader from '../../components/Cascader'
  import careditor from './CarEditor'

  export default {
    name: 'CarsLaborDialog',
    props: {
      // id: {
      //   type: String
      // },
      // refresh: {
      //   type: Function
      // },
      // closeSelf: {
      //   type: Function
      // }
    },
    data () {
      return {
        formData: {
          uuid: '',
          ryuuid: '',
          ssxzbm: '',
          cph: ''
        },
        sjcph:'',
        sjryuuid:'',
        // 校验规则
        formRules: {
          // villageCode: [
          //     {required: true, message: '请设置所属区域', trigger: 'blur'}
          // ],
          // carNo: [
          //     {required: true, message: '请设置所属区域', trigger: 'blur'}
          // ],
          // listManageArea: [
          //     {required: true, message: '请设置所属区域', trigger: 'blur'}
          // ]
        },
        tableData: [],
        // 分页参数
        pagination: {
          pageSizeList: [10, 20, 30, 40, 50],
          pageSize: 10,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          currentPage: 1
        },
        // 资源权限控制，有的系统不需这么细，则全部为true
        source: {
          add: true,
          deleteBatch: true,
          export: true,
          import: true,
          infoView: true,
          infoEdit: true,
          infoDelete: true
        },
        // 管理区域
        setManageProps: {
          multiple: true, // 多选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        // 所属区域
        setProps: {
          multiple: false, // 单选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        // 字典数据
        dictionary: {},
        loading: false,
        editableFlag: false,
        showTitle: '查看'
      }
    },
    mounted () {
      this.sjcph=this.$route.params.carInfo.cph
      this.init()
    },
    components: {
      // addCarUserTemplate,
      cascader,
      careditor
    },
    methods: {
      init: function () {
        let _this = this
        if (this.$route.params) {
          let carInfo = this.$route.params.carInfo
          _this.formData.uuid = carInfo.uuid
          _this.formData.ssxzbm = carInfo.ssxzbm
          _this.formData.cph = carInfo.cph
          let type = this.$route.params.type
          if (type === 'add') {
            this.showTitle = '新增'
          } else if (type === 'edit') {
            this.showTitle = '编辑'
            this.editableFlag = true
          } else if (type === 'view') {
            this.showTitle = '查看'
          }
          console.log(carInfo)
          // 调用级联组建内 init 方法重组默认值
          setTimeout(function () {
            _this.$refs.myArea.init(_this.formData.ssxzbm)
          }, 100)
          this.getTableData('init')
        }
      },
      goBack: function () {
        this.$router.go(-1)
      },
      handleCurrentChange: function(row) {

          this.formData.ryuuid = row.uuid
          // this.sjryuuid=row.uuid

      },
      // 获取列表
      getTableData: function (initPageFlag) {
        this.loading = true
        let _this = this, searchParams = this.searchForm
        _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
          let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
              initPageFlag ? 1 : _this.pagination.currentPage,
              initPageFlag ? 10 : _this.pagination.pageSize,
              {yhlx: 6, ssxzbm: _this.formData.ssxzbm,cph:_this.sjcph})
          let param = {
              baseService: 'TGcUserServiceImpl',
              type: 'getsjryPage',
              info: paginationData
          }
        // 3、 调接口获取数据
        _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            param,
            resultData => {
                _this.loading = false
                if (resultData) {
                    // 结果参数赋值
                    _this.pagination.pageSize = resultData.obj.size
                    _this.pagination.total = resultData.obj.total
                    _this.pagination.currentPage = resultData.obj.current
                    _this.tableData = resultData.obj.records
                } else {
                    _this.$message.warning('获取列表数据失败～')
                }
            },
            () => {
                _this.loading = false
            }
        )
      },
      // 分页方法
      tableSizeChange: function (pageSize) {
        this.pagination.pageSize = pageSize
        this.getTableData()
      },
      currentChange: function (current) {
        this.pagination.currentPage = current
        this.getTableData()
      },
      saveForm: function () {
        let _this = this
          if (!_this.formData.ryuuid) {
              this.$message.warning('请选择司机！')
              return
          }
        // 参数处理======start==========
          let params = {
              type: 'updateClByry',
              baseService: 'TGcClServiceImpl',
              info: {
                  uuid: _this.formData.uuid,
                  ryuuid: _this.formData.ryuuid
              }
          }
        // 参数处理======end============
        _this.loading = true
        _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            params,
            resultData => {
                _this.loading = false
                if (resultData.code === '200') {
                    _this.$message.success('保存成功～')
                    _this.$props.refresh && this.$props.refresh('init')
                    _this.$router.go(-1)
                } else {
                    _this.$message.warning('保存失败～')
                }
            },
            () => {
                _this.loading = false
            })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/setFunction/CarsOperateDialog.vue